import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import c from 'classnames';

import {
  Container,
  Logo,
} from '../../../components';


import AnimationWrapper from '../AnimationWrapper';
import './style.scss';

class NavigationPrivacy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      reachedTop: true,
      scrolledPastNavHeight: true,
    };
  }

  onUpdateAnimationWrapper = (isVisible, hasReachedTop, scrolledPastNavHeight) => {
    const shouldUpdate = (
      this.state.visible !== isVisible
      || this.state.reachedTop !== hasReachedTop
      || this.state.scrolledPastNavHeight !== scrolledPastNavHeight
    );

    if (shouldUpdate) {
      this.setState({
        scrolledPastNavHeight,
        visible: isVisible,
        reachedTop: hasReachedTop,
      });
    }
  };

  render() {
    const { reachedTop, visible, scrolledPastNavHeight } = this.state;

    const classes = c('NavigationPrivacy', {
      's-reached-top': reachedTop,
      's-visible': visible,
      's-scrolled-past-nav-height': scrolledPastNavHeight,
    });

    return (
      <div className="NavigationPrivacy__wrapper">
        <AnimationWrapper onUpdate={this.onUpdateAnimationWrapper} scrolledPastNavHeight={scrolledPastNavHeight}>
          <Container className="NavigationPrivacy-container">
            <div className={classes}>
              <Logo />
            </div>
          </Container>
        </AnimationWrapper>
      </div>
    );
  }
}

/**
 * @example
 * @param state
 * @param ownProps
 */
function mapStateToProps(state, ownProps) {

  return {
    showNavMenu: state.getIn(['uiInternal', 'showNavMenu']),
  };
}

export default withRouter(connect(mapStateToProps)(NavigationPrivacy));
